module.exports = __webpack_public_path__ + "assets/images/chart-blue.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/chart-blue.png
// module id = 2320
// module chunks = 0